module.exports = __webpack_public_path__ + "static/media/banner_arrow-left.9ef120da.svg";